/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestPasswordChangeRequest
 */
export interface RequestPasswordChangeRequest {
    /**
     * メールアドレス（format: email）
     * @type {string}
     * @memberof RequestPasswordChangeRequest
     */
    email: string;
}

/**
 * Check if a given object implements the RequestPasswordChangeRequest interface.
 */
export function instanceOfRequestPasswordChangeRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;

    return isInstance;
}

export function RequestPasswordChangeRequestFromJSON(json: any): RequestPasswordChangeRequest {
    return RequestPasswordChangeRequestFromJSONTyped(json, false);
}

export function RequestPasswordChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestPasswordChangeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
    };
}

export function RequestPasswordChangeRequestToJSON(value?: RequestPasswordChangeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
    };
}

